import React from 'react';
import { PcHeader as PcHeader2024 } from '@encarpkg/design';

import classNames from 'classnames/bind';
import styles from './PcHeader.module.scss';

const cx = classNames.bind(styles);
const encarPcURL = process.env.REACT_APP_ENCAR_PC;

const PcHeader = ({ title, pcHeaderType = null, pcSubMenuInfo = null, pcTitle = null, usePcLogoNoLink = false, style = null, pcHeaderInfo }) => {
	let headerMarkup;

	const pcSubMenu =
		pcSubMenuInfo &&
		pcSubMenuInfo.menu.map((item, index) => {
			const key = `gnbKey${index}`;
			return (
				<li
					key={key}
					className={cx({ active: index === pcSubMenuInfo.active })}
				>
					<a
						className={cx('link')}
						href={item.link}
					>
						{item.title}
					</a>
				</li>
			);
		});

	switch (pcHeaderType) {
		case 'carDetail':
			headerMarkup = null;
			break;
		case 'pcPopup':
			headerMarkup = (
				<div className={cx('header_pop', { useLogo: usePcLogoNoLink })}>
					<h1 className={cx(usePcLogoNoLink ? 'pc_logo' : 'blind')}>Encar</h1>
					<h2 className={cx('pop_title')}>{pcTitle || title}</h2>
				</div>
			);
			break;
		case 'pcMain':
			headerMarkup = <PcHeader2024 info={pcHeaderInfo} />;
			break;
		default:
			headerMarkup = (
				<div
					className={cx('pc_header_wrap', 'pc_header_simple')}
					style={style}
				>
					<div className={cx('pc_header')}>
						{usePcLogoNoLink ? (
							<h1 className={cx('pc_logo')}>Encar</h1>
						) : (
							<h1 className={cx('pc_logo')}>
								<a href={`${encarPcURL}/index.do?WT.hit=toplogo`}>Encar</a>
							</h1>
						)}
						{pcSubMenu ? (
							<>
								<h2 className="blind">{title}</h2>
								<ul className={cx('gnb')}>{pcSubMenu}</ul>
							</>
						) : (
							<h2 className={cx('header_title')}>{pcTitle || title}</h2>
						)}
					</div>
				</div>
			);
	}
	return headerMarkup;
};

export default PcHeader;
